import React from 'react';

const SIZE_CLASSES = {
  xs: 'h-5 w-5 text-[9px]',
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-14 w-14 text-base',
  xl: 'h-20 w-20 text-xl',
};

function initialsFromName(name = '') {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'U';
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
}

const UserAvatar = React.memo(function UserAvatar({
  src,
  name,
  size = 'md',
  className = '',
}) {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-200 font-semibold text-slate-700 ${sizeClass} ${className}`}
      aria-label={name || 'Usuario'}
    >
      {src ? (
        <img
          src={src}
          alt={name || 'Foto de perfil'}
          className="h-full w-full object-cover"
          referrerPolicy="no-referrer"
        />
      ) : (
        initialsFromName(name)
      )}
    </span>
  );
});

export default UserAvatar;
